import capitalize from './capitalize.js'
import uppercase from './uppercase.js'

export default {
  configure(Vue) {
    Vue.filter('capitalize', capitalize)
    Vue.filter('uppercase', uppercase)
  }
}
